import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { CSVLink, CSVDownload } from "react-csv";
// import { generatePDF } from "./reportPDF";

// import ReactToPdf from 'react-to-pdf';
// import { PaperReportPDF } from "./paperReportPDF";

// components
import PageHeader from "components/BreadCrumb";
import CustomPagination from "components/CustomPagination ";

// hooks
import { useTable } from "hooks/custom/useTable";

// context
import PaperReportsFilters from "components/TableFilters/PaperReportFilters";
import { paperReports, generatePaperReportPDF } from "api/v1/paper";
import { useAuthContext } from "context/auth.context";

import { BlobProvider } from '@react-pdf/renderer';
import { PaperReportPDF } from './paperReportPDF';

const csvData = [
  ["firstname", "lastname", "email"],
  ["Ahmed", "Tomi", "ah@smthing.co.com"],
  ["Raed", "Labes", "rl@smthing.co.com"],
  ["Yezzi", "Min l3b", "ymin@cocococo.com"],
];

// Create reference for paperReportPDF
// const ref = React.createRef();

const PaperReports = () => {
  const history = useHistory();
  const { user } = useAuthContext();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable();
  const [reportData, setReportData] = useState('');

const [showModal, setShowModal] = useState(false);

  // const [pdfUrl, setPdfUrl] = useState(null);
  // const [showModal, setShowModal] = useState(false);

  // const generatePdf = (toPdfFunc) => {
  //   toPdfFunc({ 
  //     onComplete: ({ blob }) => {
  //       const url = URL.createObjectURL(blob);
  //       setPdfUrl(url);
  //       setShowModal(true);
  //     }
  //   });
  // };

  // const handleGeneratePDF = (reportData) => {
  //   generatePDF(reportData);
  // }

  const submitReport = async (data) => {
    const res = await paperReports(data);
    const repData = await generatePaperReportPDF(data);
    setReportData(repData);
    console.log(repData);
    setRows(res.data);
    setLoading(false);
  };

  return (
    <div className="container-fluid">
      <PageHeader Breadcrumb={[{ name: "Papers" }]} />

      <div className="card">
        <div
          className="header"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <h2>Paper Reports</h2>

          {/* <button
            type="button"
            className="btn btn-secondary"
            title="Generate Chapter"
          >
            <span className="sr-only">Export Report</span>
            <i className="fa fa-download"></i>
            {/* <CSVLink
              data={[
                ["Paper #", "Paper Name", "Type", "Paper Date", "Created At"],
                ,
                ...rows.map((obj) => Object.values(obj)),
              ]}
              style={{ color: "#fff", marginLeft: "10px" }}
              filename={`Paper_Report_${new Date()}`}
            >
              Export Report
            </CSVLink> */}
          {/* </button> */} 
        </div>
              <div style={{ display: "flex", justifyContent: "end", paddingRight: "20px" }}>
              <button className="btn btn-primary" onClick={() => setShowModal(true)}>Generate PDF</button>

{showModal && (
  <div style={modalStyles.overlay}>
    <div style={modalStyles.content}>
      <button className="btn btn-danger" onClick={() => setShowModal(false)}>Close</button>
      <BlobProvider document={<PaperReportPDF data={reportData} />}>
        {({ url, loading }) =>
          loading ? (
            <p>Generating...</p>
          ) : (
            <>
              {/* <a href={url} download="report.pdf">
                <button>Download</button>
              </a> */}
              <iframe
                src={url}
                width="100%"
                height="400px"
                title="PDF Preview"
                style={{ border: '1px solid #ccc' }}
              />
            </>
          )
        }
      </BlobProvider>
    </div>
  </div>
)}
              </div>
        <PaperReportsFilters submitReport={submitReport} />

        <div className="body table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Paper #</th>
                <th>Paper Name</th>
                <th>Type</th>
                <th>Paper Date</th>
                <th>Created At</th>
                <th style={{ textAlign: "end" }}>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td></td>
                  <td></td>
                  <td
                    style={{
                      textAlign: "center",
                      height: "30vh",
                      width: "100%",
                    }}
                    className="visible-lg"
                  >
                    <i className="fa fa-spinner fa-4x fa-spin"></i>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              ) : (
                <>
                  {rows?.length > 0 ? (
                    rows
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row) => (
                        <tr key={row?.id}>
                          <td>{row.id} </td>
                          <td>{row.paper_title}</td>
                          <td>{row.type_name}</td>
                          <td>{new Date(row.paper_date).toDateString()}</td>
                          <td>{new Date(row.created_at).toDateString()}</td>
                          <td
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-primary mr-1"
                              title="View"
                              onClick={() => history.push(`/papers/${row.id}`)}
                            >
                              <span className="sr-only">View</span>
                              <i className="fa fa-eye"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td></td>
                      <td></td>
                      <td
                        style={{
                          textAlign: "center",
                          height: "30vh",
                          fontSize: "1.5rem",
                          width: "100%",
                        }}
                      >
                        Oops! No data found
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>

        <div className="body" style={{ paddingTop: 0, paddingBottom: 0 }}>
          <CustomPagination
            count={rows.length}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

const modalStyles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
    justifyContent: 'center', alignItems: 'center', zIndex: 1000
  },
  content: {
    background: '#fff', padding: 20, borderRadius: 8,
    width: '80%', maxWidth: 800, position: 'relative'
  }
};

export default PaperReports;
